<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { alert, callback } = defineProps({
    alert: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route('front.postToggleAlertProcessedAt', {
                alert: alert.id,
            }),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
